import { IDefaultTemplates } from "../Models";
import { baseUrl, getTokenFromLocalStorage } from "./Configuration";

interface IAutomaticResponse {
  id: string;
  listingID: string;
  emailBody: string;
}

export async function fetchAutomaticResponseHistory(
  typeOfResponse: string,
  Last24Hrs: boolean,
  page: number,
  pageSize: number,
  searchTerm: string = "",
) {
  try {
    const url =
      baseUrl +
      `/api/Showings/GetAutomaticResponseHistory/${typeOfResponse}?Last24Hrs=${Last24Hrs}&page=${page}&pageSize=${pageSize}&searchTerm=${searchTerm}`;

    console.log("🔵 API CALL: fetchAutomaticResponseHistory");
    console.log(`  URL: ${url}`);

    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
      },
    });

    console.log(`  HTTP Status: ${response.status}`);

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    console.log(`  Response data:`, data);
    console.log(`  Items count: ${data?.items?.length || data?.length || 0}`);

    return data;
  } catch (error) {
    console.error("❌ Error in fetchAutomaticResponseHistory:", error);
    throw error;
  }
}

export async function GetHistoryByArhId(arhId: string) {
  try {
    const response = await fetch(
      baseUrl + `/api/Reminder/GetHistoryByArhId/${arhId}`,
      {
        headers: {
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
      },
    );

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
}

//change it to pass the email body only once
export async function SaveAutomaticResponse(
  automaticResponse: IAutomaticResponse[],
) {
  const url = baseUrl + "/api/Showings/SaveEmail";
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };

  const requestBody = {
    automaticResponse: automaticResponse,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(requestBody),
    });

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error("Failed to save appointments");
    }

    return await response.json();
  } catch (error: any) {
    throw new Error(`Error: ${error.message}`);
  }
}

export async function fetchAutomaticResponseForListing(listingID: string) {
  try {
    const response = await fetch(
      baseUrl + "/api/Showings/GetAutomaticResponseForListing/" + listingID,
      {
        headers: {
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
      },
    );

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export async function fetchAutomaticResponseById(AutoResponseId: string) {
  try {
    const response = await fetch(
      baseUrl + "/api/Showings/GetAutomaticResponseById/" + AutoResponseId,
      {
        headers: {
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
      },
    );

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export async function fetchAppointmentResponse(
  automaticResponseHistoryId: string,
  confirmed: boolean,
  selectedAppointmentId?: string,
  phone?: string,
  memberGuarantorInfos?: {
    id: string;
    name: string;
    isGuarantor: boolean;
  }[],
) {
  try {
    if (!selectedAppointmentId)
      selectedAppointmentId = "00000000-0000-0000-0000-000000000000";
    if (memberGuarantorInfos) {
      memberGuarantorInfos.forEach((e) => {
        if (!e.id || !e.id.includes("-")) {
          e.id = "00000000-0000-0000-0000-000000000000";
        }
      });
    }
    const response = await fetch(
      baseUrl + `/api/Appointments/${automaticResponseHistoryId} `,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
        body: JSON.stringify({
          confirmed,
          selectedAppointmentId,
          memberGuarantorInfos,
          phone,
        }),
      },
    );

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
}

export async function fetchAutomaticResponseHistoryByListingId(
  listingId: string,
) {
  try {
    const response = await fetch(
      baseUrl +
        "/api/Showings/GetAutomaticResponseHistoryByListingId/" +
        listingId,
      {
        headers: {
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
      },
    );

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
}

export async function saveEmailTemplate(
  apartmentId: string,
  emailBody: string,
  emailType: string,
) {
  try {
    // Since the API is incorrectly using multiple [FromBody] parameters,
    // we'll send everything as a single JSON object
    const response = await fetch(baseUrl + "/api/Showings/SaveEmailTemplate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
      },
      body: JSON.stringify({
        apartmentId,
        emailType,
        emailBody,
      }),
    });

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`Server responded with status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error saving email templates:", error);
    throw error;
  }
}

export async function saveNewEmailTemplateType(body: IDefaultTemplates) {
  try {
    // Since the API is incorrectly using multiple [FromBody] parameters,
    // we'll send everything as a single JSON object
    const response = await fetch(
      baseUrl + "/api/Appointments/SaveDefaultTemplate",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
        body: JSON.stringify(body),
      },
    );

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`Server responded with status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error saving email templates:", error);
    throw error;
  }
}

export async function getEmailTemplates(apartmentId: string) {
  try {
    const response = await fetch(
      baseUrl + `/api/Showings/GetEmailTemplates/${apartmentId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
      },
    );

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`Server responded with status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error fetching email templates:", error);
    throw error;
  }
}

export async function getDefaultEmailTemplates() {
  try {
    const response = await fetch(
      baseUrl + `/api/Appointments/GetDefaultTemplate`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
      },
    );

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`Server responded with status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error fetching email templates:", error);
  }
}

export async function fetchAutomaticResponseHistoryById(id: string) {
  try {
    const response = await fetch(
      baseUrl + `/api/Showings/GetAutomaticResponseHistoryById/${id}`,
      {
        headers: {
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
      },
    );

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
}
